import { render, staticRenderFns } from "./column_header.vue?vue&type=template&id=d97d5e52&"
import script from "./column_header.vue?vue&type=script&lang=js&"
export * from "./column_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports